// extracted by mini-css-extract-plugin
export default {"headline":"runway__headline__20wIU","title":"runway__title__3MItH","glow":"runway__glow__3yCSl","demo-link":"runway__demo-link__74s68","demoLink":"runway__demo-link__74s68"};